'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const CircledUserIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="CircledUserIcon">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_19_17961)">
          <path
            d="M0 20C0 25.3043 2.10714 30.3914 5.85786 34.1421C9.60859 37.8929 14.6957 40 20 40C25.3043 40 30.3914 37.8929 34.1421 34.1421C37.8929 30.3914 40 25.3043 40 20C40 14.6957 37.8929 9.60859 34.1421 5.85786C30.3914 2.10714 25.3043 0 20 0C14.6957 0 9.60859 2.10714 5.85786 5.85786C2.10714 9.60859 0 14.6957 0 20Z"
            fill="#D8DCE5"
          />
          <path
            d="M12.8567 14.2845C12.8567 16.1789 13.6092 17.9957 14.9488 19.3352C16.2883 20.6748 18.1051 21.4273 19.9995 21.4273C21.8939 21.4273 23.7107 20.6748 25.0503 19.3352C26.3898 17.9957 27.1424 16.1789 27.1424 14.2845C27.1424 12.3901 26.3898 10.5732 25.0503 9.2337C23.7107 7.89415 21.8939 7.1416 19.9995 7.1416C18.1051 7.1416 16.2883 7.89415 14.9488 9.2337C13.6092 10.5732 12.8567 12.3901 12.8567 14.2845Z"
            fill="#3D517B"
          />
          <path
            d="M32.1236 30.001C30.6506 28.2121 28.7995 26.7718 26.7033 25.7837C24.6072 24.7957 22.3181 24.2844 20.0007 24.2868C17.6834 24.2844 15.3943 24.7957 13.2982 25.7837C11.202 26.7718 9.35088 28.2121 7.87789 30.001C9.35088 31.79 11.202 33.2303 13.2982 34.2184C15.3943 35.2064 17.6834 35.7177 20.0007 35.7153C22.3181 35.7177 24.6072 35.2064 26.7033 34.2184C28.7995 33.2303 30.6506 31.79 32.1236 30.001Z"
            fill="#3D517B"
          />
        </g>
        <defs>
          <clipPath id="clip0_19_17961">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

CircledUserIcon.propTypes = {
  sx: PropTypes.object
}
